/**
 * Trigger a browser download for an in-memory Blob (e.g. a PDF fetched from
 * the backend via `fetchBlob`). Generalises the anchor-click pattern in
 * `project-planning/export-csv.ts` so any feature can save a fetched file.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Defer revocation so the navigation/download has started before the URL is
  // invalidated (matches the export-csv helper).
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 100);
}
